import { Link, createFileRoute } from '@tanstack/react-router';

import { useAuth } from '@/lib/auth/useAuth';

export const Route = createFileRoute('/403')({
  component: AccessDeniedRoute,
});

function AccessDeniedRoute() {
  const { profile } = useAuth();
  const home =
    profile?.role === 'admin' || profile?.role === 'moderator'
      ? '/admin'
      : profile?.role === 'creator' && profile?.creator_status === 'approved'
        ? '/creator'
        : '/subscriber';
  return (
    <div className="flex min-h-screen items-center justify-center bg-parchment px-6">
      <div className="max-w-md text-center">
        <h1 className="font-serif text-4xl text-ink">This area is restricted.</h1>
        <p className="mt-6 font-sans text-base text-ink/70 pretty">
          ArcheTelos uses role-based access — admin queues, contributor tools, and subscriber feeds
          live behind their own permissions. Your account doesn&apos;t have the role required for
          that page.
        </p>
        <Link
          to={home}
          className="mt-8 inline-block rounded-md bg-ink px-4 py-2 font-sans text-sm font-medium text-parchment hover:bg-oxblood"
        >
          Back to your home
        </Link>
      </div>
    </div>
  );
}
